import { computed, getCurrentInstance } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import { MUTATION_TYPES } from "@/store/const";
import { StateRoot } from "@/store/state";
import { AgeStatus, isAdult } from "@/lib/ageHelpers";
import config from "@/config";

export default function useNSFWUserSettings() {
  const vm = getCurrentInstance();
  const { authUser } = useAuthUser();

  const dateOfBirth = computed(() => (vm ? (vm.$store.state as StateRoot).dateOfBirth : undefined));

  const ageStatus = computed(() => {
    if (!authUser.value || dateOfBirth.value === undefined) return AgeStatus.UNKNOWN;
    if (dateOfBirth.value === null) return AgeStatus.MISSING;
    return isAdult(dateOfBirth.value) ? AgeStatus.ADULT : AgeStatus.MINOR;
  });

  const showNotSafeForWork = computed(() => (!config.featureNSFW ? true : ageStatus.value === AgeStatus.ADULT));

  const setDateOfBirth = (value: string) => {
    vm?.$store.commit(MUTATION_TYPES.SET_STATE, { dateOfBirth: value });
  };

  return {
    showNotSafeForWork,
    ageStatus,
    dateOfBirth,
    setDateOfBirth,
  };
}
